import { render, staticRenderFns } from "./mapping_colonnes.vue?vue&type=template&id=64e90df4&scoped=true"
import script from "./mapping_colonnes.vue?vue&type=script&lang=js"
export * from "./mapping_colonnes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e90df4",
  null
  
)

export default component.exports